import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHZonaUpd = async (credentials, data) => {
    const body = {
        service: "RNHZonaUpd",
        params: {
            rnhZonaId: data?.id,
            rnhZonaCod: data?.cod,
            rnhZonaNombre: data?.name,
            rnhZonaWKT: data?.wkt,
            rnhZonaVersion: data?.version,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
